// extracted by mini-css-extract-plugin
export default {"log-item-card":"log-item-card_log-item-card__R0Xoc"};